import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { BaseEditService } from '../../../tms-shared';
import { User, UserChart, UserDetails, UserPrinterDocument, UserRole } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseEditService<User, UserDetails> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('User', $localize`User`);
  }

  checkEmail(email: string): Observable<boolean> {
    return this.httpService.get<boolean>(`${this.apiUrl}/CheckEmail?email=${encodeURIComponent(email)}`);
  }

  checkEmailAndCustomerId(email: string, customerId: string): Observable<boolean> {
    return this.httpService.get<boolean>(
      `${this.apiUrl}/CheckEmailAndCustomerId?email=${encodeURIComponent(email)}&customerId=${customerId}`,
    );
  }

  getUserByName(userName: string): Observable<UserDetails> {
    return this.httpService.get<UserDetails>(`${this.apiUrl}/GetUserByName?userName=${userName}`);
  }

  getUserRoles(userId: string): Observable<UserRole[]> {
    return this.httpService.get<UserRole[]>(`${this.apiUrl}/GetUserRoles/${userId}`);
  }

  updateUserRoles(userId: string, roleIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateUserRoles`, { userId, roleIds });
  }

  getSelectedUserCharts(): Observable<string[]> {
    return this.httpService.get<string[]>(`${this.apiUrl}/GetSelectedUserCharts`);
  }

  getUserCharts(userId: string): Observable<UserChart[]> {
    return this.httpService.get<UserChart[]>(`${this.apiUrl}/GetUserCharts/${userId}`);
  }

  getUserPrinterForDocument(userId: string, documentName: string): Observable<UserPrinterDocument> {
    return this.httpService.get<UserPrinterDocument>(
      `${this.apiUrl}/GetUserPrinterForDocument?userId=${userId}&documentName=${documentName}`,
    );
  }

  updateUserCharts(userId: string, chartIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateUserCharts`, { userId, chartIds });
  }

  createCustomerPortalUsers(customerIds: string[]): Observable<string[]> {
    return this.httpService.post(`${this.apiUrl}/CreateCustomerPortalUsers`, { customerIds });
  }
}
